
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      imageSize: `1536x1536`,
    };
  },
  computed: {
    image () {
      let image = null;
      if (this.post.image) {
        image = this.post.image;
      }

      return {
        src: image ? image.thumbnail : this.$store.state.config.default_page_image[this.imageSize],
        srcset: image?.srcset || ``,
        alt: image?.alt || this.title,
        position: image ? this.post.acf.featured_image_position : `center center`,
      };
    },
    heroStyle () {
      return this.post.acf.hero_style;
    },
    isFullWidth () {
      return this.heroStyle === `full-width`;
    },
    colour () {
      // TODO: Nicer way to do this?
      return {
        '--hero-colour': this.isFullWidth ? `rgba(14,14,14,.7)`
          : this.post.acf.hero_colour === `grey500`
            ? `#0E0E0E`
            : this.post.acf.hero_colour === `white`
              ? `#FFF`
              : `#ECECEC`,
      };
    },
    isLight () {
      return this.post.acf.hero_style === `full-width` || this.post.acf.hero_colour === `grey500`;
    },
  },
};
